module.exports = __webpack_public_path__ + "static/media/scheduleIcon.cc463ea8.svg";